var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReviewStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2702_15245)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0.00634766H24V24.0063H0V0.00634766Z",
    fill: "#22B5FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9932 15.8383L15.6412 14.9138L17.1654 19.6112L11.9932 15.8383ZM20.3887 9.7665H13.9671L11.9932 3.71973L10.0192 9.7665H3.59766L8.79488 13.5145L6.82094 19.5613L12.0182 15.8133L15.2165 13.5145L20.3887 9.7665Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2702_15245"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReviewStar);
export default __webpack_public_path__ + "static/media/review-star.d2c40ed67e5d7aed5dadb28d801017ad.svg";
export { ForwardRef as ReactComponent };